import { useState } from "react";
import { saveCustomerType } from "../Api/CustomerType";
import { Container, Form, Button, Row, Col, Accordion, AccordionBody, AccordionItem, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import { useAuth } from "../Context/AuthContext";

const CustomerType = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState("");

  const userName = localStorage.getItem("username") || "defaultUser";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!description.trim()) {
      toast.error("Description is required");
      return;
    }

    const payload = {
      OrganisationId: user?.organisationId,
      Description: description.trim(),
    };

    setLoading(true);
    try {
      await saveCustomerType(payload, userName);
      toast.success("🦄 Customer Type Added Successfully");
      setDescription("");
    } catch (error) {
      console.error(error);
      const msg = typeof error === "string" ? error : "Some Error Happened";
      toast.error(`🦄 ${msg}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-content expand">
      <Container fluid className="fields-container">
        <h2 className="fields-title">Customer Type</h2>

        <Form onSubmit={handleSubmit} className="fields-form">
          <Accordion defaultActiveKey="0">
            <AccordionItem eventKey="0">
              <AccordionBody>
                <Row className="g-3">
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Organisation Id <span className="text-red">**</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={user?.organisationId ?? ""}
                        disabled
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Description <span className="text-red">**</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="Description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </AccordionBody>
            </AccordionItem>
          </Accordion>

          <div className="fields-btn-container" style={{ marginTop: 16 }}>
            <Button variant="primary" type="submit" className="fields-submit" disabled={loading}>
              {loading ? <><Spinner animation="border" size="sm" className="me-2" />Saving…</> : "Save Customer Type"}
            </Button>
          </div>
        </Form>
      </Container>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </div>
  );
};

export default CustomerType;